import React from 'react';
import chassisImg from './Logos/Assets/Chassis.png';
import './Styles/Subsystems.css';

const ChassisPage = () => {
    return (
        <div className="subsystem-page">
            <h1>Chassis Subsystem</h1>
            <img src={chassisImg} alt="Chassis" className="subsystem-image" />
            <p>
                The Chassis team builds the frame that holds everything together. Our job is to make sure TONE is strong, secure, and ready to take hits while keeping all the parts safe and in place. Every piece of the robot depends on the chassis to stay connected and supported during combat.
                <br /><br />
                We focus on strength and structure, while also making it easy to access and adjust parts when needed. A solid chassis means we can fight harder and recover faster between matches. It's the core that makes sure the robot holds up under pressure.
            </p>
        </div>
    );
};

export default ChassisPage;
